import appStore from 'store';
import api from './api';
import {
  PAGINATION
} from './constants';

const store = {
  namespaced: true,
  state: {
    userList: [],
    totalCount: 0,
    pagination: PAGINATION,

  },
  getters: {

  },
  mutations: {
    setUserList(state, payload) {
      state.userList = payload ? payload.items.slice() : [];
      state.totalCount = payload ? payload.total : 0;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setQueryType(state, payload) {
      state.queryType = payload;
    },

  },
  actions: {
    list({ commit }, query = {}) {
      commit('setPagination', { page: query.page, size: query.size });
      api.getUserList(query).then(res => {
        if (res.code == 0) {
          commit('setUserList', res.data);
        }
      });
    },
    sendCoin({ commit }, query = {}) {

      return api.sendCoin(query).then(res => {
        if (res.code == 0) {
          return res
        }
      });
    },


  }
};

appStore.registerModule('headInch', store);
